/* Murovea : offre flash réelle (dates fixées dans Shopify, les mêmes pour tout le monde) */
(function(){
  var F = window.MV_FLASH || {};
  var debut = F.debut ? new Date(F.debut) : null, fin = F.fin ? new Date(F.fin) : null, pct = parseInt(F.pct, 10) || 10;
  var apercu = /[?&]mvflash=test/.test(location.search) && window.Shopify && Shopify.theme && Shopify.theme.role !== "main";
  if (apercu) { debut = new Date(Date.now() - 6e4); fin = new Date(Date.now() + 72 * 36e5 - 1000); }
  if (!debut || !fin || isNaN(debut) || isNaN(fin)) return;
  var barres = [], ligne = null, timer = null;
  function reste(){ return fin - new Date(); }
  function actif(){ var n = new Date(); return n >= debut && n < fin; }
  function hms(ms){
    var s = Math.max(0, Math.floor(ms / 1000)), h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    return h + ":" + (m < 10 ? "0" : "") + m + ":" + (x < 10 ? "0" : "") + x;
  }
  function style(){
    if (document.getElementById("mv-flash-style")) return;
    var st = document.createElement("style"); st.id = "mv-flash-style";
    st.textContent = ".mv-flash-t{font-variant-numeric:tabular-nums}"
      + ".mv-flash-line{margin:6px 0 -6px;text-align:center;font-size:14px;font-weight:700;color:#5E7F5A}"
      + "@media(max-width:749px){.announcement-bar__text.mv-flash-on{font-size:13px!important}}";
    document.head.appendChild(st);
  }
  function tick(){
    if (!actif()) { stop(); return; }
    var t = hms(reste());
    barres.forEach(function(b){ b.el.innerHTML = "OFFRE FLASH : -" + pct + " % EN PLUS · FIN DANS <span class=\"mv-flash-t\">" + t + "</span> ⏳"; });
    if (ligne) ligne.innerHTML = "Offre flash : -" + pct + " % en plus au panier, fin dans <span class=\"mv-flash-t\">" + t + "</span>";
  }
  function stop(){
    if (timer) clearInterval(timer); timer = null;
    barres.forEach(function(b){ b.el.innerHTML = b.html; b.el.classList.remove("mv-flash-on"); });
    if (ligne && ligne.parentNode) ligne.parentNode.removeChild(ligne);
  }
  function start(){
    if (new Date() >= fin) return;
    if (new Date() < debut) { setTimeout(start, Math.min(debut - new Date() + 500, 2147483000)); return; }
    style();
    [].forEach.call(document.querySelectorAll(".announcement-bar__text"), function(el){
      if (!/BIENVENUE/i.test(el.textContent)) return;
      barres.push({ el: el, html: el.innerHTML }); el.classList.add("mv-flash-on");
    });
    var fin31 = document.querySelector(".mv-offer-end");
    if (fin31) { ligne = document.createElement("p"); ligne.className = "mv-flash-line"; fin31.parentNode.insertBefore(ligne, fin31.nextSibling); }
    tick(); timer = setInterval(tick, 1000);
  }
  if (document.readyState !== "loading") start(); else document.addEventListener("DOMContentLoaded", start);
})();
/* Murovea : message rouge quand des couleurs sont réellement épuisées (compte automatique) */
(function(){
  var MOTS = ["", "une couleur est déjà épuisée", "deux couleurs sont déjà épuisées", "trois couleurs sont déjà épuisées"];
  var msg = null, styled = false;
  function colorSet(){
    var sets = document.querySelectorAll("variant-picker fieldset");
    for (var i = 0; i < sets.length; i++) { if (sets[i].querySelector('input[value="Noir mat"]')) return sets[i]; }
    return null;
  }
  function style(){
    if (styled) return; styled = true;
    var st = document.createElement("style");
    st.textContent = ".mv-alerte-stock{color:#C62828;font-weight:700;font-size:14px;margin:4px 0 10px}"
      + "variant-picker .variant-option:has(input[value=\"Noir mat\"]) .variant-option__button-label:has(input[data-option-available=\"false\"]){opacity:.5}"
      + "variant-picker .variant-option:has(input[value=\"Noir mat\"]) .variant-option__button-label:has(input[data-option-available=\"false\"]) .variant-option__button-label__text{text-decoration:line-through!important}";
    document.head.appendChild(st);
  }
  function place(){
    var fs = colorSet(); if (!fs) return;
    style();
    var n = fs.querySelectorAll('input[data-option-available="false"]').length;
    if (!n) { if (msg && msg.parentNode) msg.parentNode.removeChild(msg); return; }
    if (!msg) { msg = document.createElement("p"); msg.className = "mv-alerte-stock"; msg.setAttribute("role", "status"); }
    var t = "Attention, " + (MOTS[n] || (n + " couleurs sont déjà épuisées")) + ".";
    if (msg.textContent !== t) msg.textContent = t;
    if (fs.nextElementSibling !== msg) fs.parentNode.insertBefore(msg, fs.nextSibling);
  }
  function start(){
    if (!document.querySelector("variant-picker")) return;
    place();
    new MutationObserver(place).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-option-available"] });
  }
  if (document.readyState !== "loading") start(); else document.addEventListener("DOMContentLoaded", start);
})();
